module.exports = __webpack_public_path__ + "img/img_futa_smoothstitch.462bcebd.png";